import { once } from 'ramda';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose, withHandlers } from 'recompose';

import {
  deleteShopDebitCard,
  deleteBarberDebitCard,
} from '../../actions';
import { getRoleIdType, getIsAdminUser } from '../../../../auth/selectors';

const mapStateToProps = state => ({
  shopOrBarber: getRoleIdType(state),
  isAdmin: getIsAdminUser(state),
});

const mapDispatchToProps = dispatch => ({
  deleteDebitCard: bindActionCreators({
    shop: deleteShopDebitCard,
    barber: deleteBarberDebitCard,
  }, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    remove: props => once(() => props.deleteDebitCard[props.shopOrBarber.type](props.shopOrBarber.id)),
  })
);
